import Network from 'infrastructure/js/modules/network';

export function getShipmentsByDataQuery(query) {
  return Network.post(`shipments/items`, query);
}

export function confirmShipmentStatus(id) {
  return Network.post(`shipments/${id}/confirmshipment`);
}

export function rejectShipment(id) {
  return Network.put(`shipments/${id}/rejection`);
}

export function downloadShipment(id) {
  return Network.get(`shipments/${id}/document`, {}, { blobResponse: true });
}

export function addToShipment(data) {
  return Network.post('shipments/add-assets', data);
}

export function validateAssignment(data) {
  return Network.post('shipments/validate-assignment', data);
}
export function shipmentReadyToShip(shipmentId, locationId) {
  return Network.post(`shipments/${shipmentId}/asn-ready-to-ship`, { locationId });
}

export function markShipmentAsReceived(shipmentId, locationId, skipExternalSensors) {
  return Network.post(`shipments/${shipmentId}/mark-as-received`, { locationId, skipExternalSensors });
}

export function deleteShipment(shipmentId, locationId) {
  return Network.delete(`shipments/${shipmentId}/asn-delete`, { locationId });
}

export function shipToCustomer(data) {
  return Network.post('shipments/ship-to-customer', data);
}
export function uploadTemperatureLogFile(id, file) {
  return Network.postFile(`shipments/${id}/temp-log-file/upload`, file);
}

export function reduceShipmentAssetsEtls({ id, ...body }) {
  return Network.put(`shipments/${id}/asset-etls`, body);
}

export function getExternalShipmentSensors(shipmentId, sensorProviderId) {
  return Network.post(`shipments/${shipmentId}/sensor-provider/${sensorProviderId}/sensors`);
}

export function assignSensorToExternalShipment({ shipmentId, sensorId, sensorName, locationId }) {
  return Network.post(`shipments/${shipmentId}/sensors`, { sensorId, sensorName, locationId });
}

export function unAssignSensorFromExternalShipment(shipmentId, sensorId, locationId) {
  return Network.delete(`shipments/${shipmentId}/sensors`, { sensorId, locationId });
}

export function stopExternalShipment(shipmentId, locationId) {
  return Network.post(`shipments/${shipmentId}/stop`, { locationId });
}

export function externalShipmentErrorNotification(shipmentId) {
  return Network.post(`shipments/${shipmentId}/send-external-notifications`);
}

export function getShipmentDetails(shipmentId) {
  return Network.get(`shipments/${shipmentId}`);
}

export function getShipmentLots(shipmentId, query) {
  return Network.post(`shipments/${shipmentId}/coc-summary`, query);
}
